import React, { memo } from 'react';
import Div from '@/shared/Div';
import classNames from 'classnames';
import Price from './Price';
import NCEMI from './NCEMI';
import Span from '@/shared/Span';
import Heading from '@/shared/Heading';
import { CouponItem } from './AddToCart';
import { getFormattedPrice } from '@/utils/price';
import useEcomProduct from '@/hooks/useEcomProduct';
import Paragraph from '@/shared/Paragraph';
import Checked from '../Icons/Checked';
// import Commission from '../seller/Commission';

const ProductName = ({
  background = 'bg-cs-brand',
  title,
  dataTestId,
  renderAddToCartCTA,
  price,
  commercial,
  sellerPage = false,
  commission,
}: {
  background?: string;
  title: string;
  MOP?: string;
  dataTestId?: string;
  price?: any;
  renderAddToCartCTA: (data: any) => JSX.Element;
  commercial: boolean;
  sellerPage?: boolean;
  commission?: any;
}) => {
  const { materialId, mrp = '', sellingPrice = '', ncemi, coupons } = price || {};

  const product = useEcomProduct(materialId);

  const filteredCoupons = coupons?.filter((coupon: any) => coupon.applicableDisc > 0);

  const findFeaturedCoupon = (couponsData: CouponItem[] | undefined): CouponItem | undefined => {
    return couponsData?.find((coupon) => coupon?.featured === true);
  };
  const featuredCoupon = findFeaturedCoupon(filteredCoupons);

  return (
    <Div
      className={classNames(
        'w-full py-s5 px-s5 lg:py-6 lg:px-6  lg:flex lg:justify-between items-center shadow-bold sticky top-14 lg:top-18.8 z-10',
        background,
      )}
      dataTestId={dataTestId}
    >
      <Heading className="text-cti-on-primary text-h-3 lg:text-hd-2 border-opacity-20 lg:border-none lg:pb-0 font-primary line-clamp-1">
        {title}
      </Heading>
      <Div
        className="my-3.5 lg:my-0 border-b border-cm-subtle border-solid  border-opacity-20 lg:border-none"
        forceRender={true}
      />
      <Div className="flex justify-between items-end lg:pt-0 lg:gap-x-s8">
        {commercial ? null : (
          <Span className="w-[210px]">
            <Price
              value={{
                sellingPrice,
                mrp,
              }}
              type="addToCartWithHeader"
            />
            {product?.appliedCoupon ? (
              <Div className="flex align-baseline gap-s2 items-center">
                <Checked />
                <Paragraph className="text-cu-positive text-body-sm lg:text-body-base leading-loose">
                  {getFormattedPrice(product?.appliedCoupon?.applicableDisc)} coupon on Checkout
                </Paragraph>
              </Div>
            ) : null}
            {!product?.appliedCoupon && featuredCoupon && !sellerPage && (
              <Div className="text-body-sm lg:text-body-base text-blue-300">
                {getFormattedPrice(featuredCoupon.applicableDisc)} coupon on checkout
              </Div>
            )}
            {sellerPage ? null : <NCEMI data={ncemi} />}
            {/* {sellerPage && commission ? (
              <Commission commission={commission} sellingPrice={sellingPrice} />
            ) : null} */}
          </Span>
        )}
        <Div className="lg:w-[20.5rem]">
          {renderAddToCartCTA &&
            renderAddToCartCTA({
              theme: 'primaryOnColor',
              className: 'w-full min-w-[144px]',
              dataTestId: 'fixed-add-to-cart-button',
              showBlackShareIcon: true,
            })}
        </Div>
      </Div>
    </Div>
  );
};

export default memo(ProductName);
